<template>
  <div class="welcome">
    <h1>Inspire Leadership School</h1>
    <div class="login-formcard">
      <h2>Login to access more features</h2>
      <LoginForm @login="enterChat" />
      <p>Not enrolled yet? <span>
        <router-link
          :to="{ name: 'Contact'}"
        >
          Get in touch
        </router-link></span> instead.</p>
    </div>
    <div class="login-img">
      <img src="../assets/crayons.jpg" alt="sign in image">
    </div>
    <h4>Creating Leaders Through Education</h4>
  </div>
</template>

<script>
import LoginForm from '@/components/LoginForm.vue'
import { inject, watchEffect } from 'vue'
import { useRouter } from 'vue-router'

export default {
  components: { LoginForm },
  setup () {
    const router = useRouter()
    const currentUser = inject('currentUser')

    const roleCheck = () => {
      if (currentUser.state.role === 'testAdmin') {
        router.push({ name: 'Administration' })
      }
      if (currentUser.state.role === 'teacher') {
        router.push({ name: 'Staff' })
      }
      if (currentUser.state.role === 'learner') {
        router.push({ name: 'Parents' })
      }
    }

    watchEffect(() => {
      if (currentUser.state.user) {
        roleCheck()
      }
    })

    const enterChat = () => {
      roleCheck()
    }

    return { enterChat }
  }
}
</script>

<style>
  .welcome {
    text-align: center;
    padding: 40px 0;
    width: 100%;
    display: grid;
    grid-gap: 0;
    grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
    min-height: 100vh;
    place-items: center;
  }
  .welcome h2, .welcome p {
    color: #fff;
  }
  .welcome h2 {
    margin-bottom: 0;
    margin-top: 1em;
  }
  .welcome span{
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
  }
  .welcome button {
    margin: 20px auto;
  }
  .welcome .login-formcard {
    background: var(--inspire-pewter);
    width: 100%;
  }
  @media (max-width: 550px) {
    .welcome {
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    }
  }
</style>
